import { useEffect } from 'react';

// The catalog's full-bleed background layers (.product-catalog-nav::before and
// .product-detail-hero-bg-layer in components/product-catalog/product-catalog.css) are 100vw wide
// so the nav strip and hero read as one continuous band edge-to-edge. 100vw includes the vertical
// scrollbar, so those layers sit slightly wider than the viewport's client width and would add a
// horizontal scrollbar unless an ancestor clips them.
//
// That clip has to land on <main>: it is the only ancestor as wide as the viewport, which is the
// very reason the layers break out of their own (inset) containers in the first place. Clipping on
// any wrapper inside it — the PDP page div, the nav div — would clip the bleed away along with the
// overhang. <main> is rendered by the AvaApp shell rather than by this app though, and
// product-catalog.css is a plain global stylesheet, so a bare `main { ... }` rule would also clip
// legitimately scrollable content (wide tables, carousels) on other microfrontends' pages sharing
// that shell. Toggling a class for exactly as long as a full-bleed page is mounted keeps the clip
// scoped to the pages that need it.
export const FULL_BLEED_MAIN_CLASS = 'product-catalog-full-bleed';

export const useFullBleedMain = (enabled = true): void => {
  useEffect(() => {
    if (!enabled) return;

    // Resolved on each run rather than once: the shell owns this element, so it can be replaced
    // between mounts. Absent on pages that render outside the AvaApp shell, hence the optional call.
    const main = document.querySelector('main');

    main?.classList.add(FULL_BLEED_MAIN_CLASS);

    return () => main?.classList.remove(FULL_BLEED_MAIN_CLASS);
  }, [enabled]);
};
